const CAPTURE_DELAY_MS = 150;

export class ReadingAnchorKeeper {
    constructor({ capture, isVisible }) {
        this._capture = capture;
        this._isVisible = isVisible;
        this.anchor = null;
        this.isFrozen = false;
        this.revision = 0;
        this._captureTimer = null;
        this._disposed = false;
    }

    get isDisposed() {
        return this._disposed;
    }

    notePositionChanged() {
        // A move the reader makes arrives as noteUserNavigation first and drops
        // the anchor, so a report while one is held is a reflow settling.
        if (this.isFrozen || this._disposed || this.anchor) return;
        this.cancelCapture();
        this._captureTimer = setTimeout(() => {
            this._captureTimer = null;
            this.anchor = this._capture();
        }, CAPTURE_DELAY_MS);
    }

    noteUserNavigation() {
        this.cancelCapture();
        this.anchor = null;
        this.revision++;
    }

    cancelCapture() {
        clearTimeout(this._captureTimer);
        this._captureTimer = null;
    }

    freeze({ resize = false } = {}) {
        if (this._disposed) return null;
        // A resize reports geometry already in motion, so it keeps the last
        // settled anchor rather than capturing an intermediate one.
        if (!this.isFrozen && !resize && (!this.anchor || !this._isVisible(this.anchor))) {
            this.anchor = this._capture();
        }
        // A capture armed before this call would overwrite the anchor above
        // with a mid-reflow read.
        this.cancelCapture();
        this.isFrozen = true;
        return { anchor: this.anchor, revision: this.revision };
    }

    canRestore(held) {
        return !this._disposed && held?.revision === this.revision;
    }

    release() {
        this.isFrozen = false;
    }

    dispose() {
        this._disposed = true;
        this.noteUserNavigation();
        this.release();
    }
}
